/**
    * @description      : 
    * @author           : 
    * @group            : 
    * @created          : 10/02/2026 - 17:27:01
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 10/02/2026
    * - Author          : 
    * - Modification    : 
**/

import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  const version = "0.9.9.7_c";

  return (
    <React.Fragment>
      <div
        className="container-fluid px-4"
        style={{
          backgroundColor: "#F8FAFD",
          position: "fixed",
          bottom: "0px",
          zIndex: 1050,
          borderTop: "1px solid #e9ecef",
          height: "auto",
          minHeight: "40px"
        }}
      >
        <div className="d-flex flex-wrap justify-content-between align-items-center py-2">
          
          {/* LEFT SECTION: Copyright + Beta Badge */}
          <div className="d-flex align-items-center flex-wrap">
            <Link 
              to={"https://pv-glarecheck.com"} 
              className="text-decoration-none text-dark fw-medium me-3"
              style={{ fontSize: "0.9rem" }}
            >
              &copy; {new Date().getFullYear()} PV-GlareCheck
            </Link>
            
            {/* Professional Beta Badge */}
            <div 
              className="d-flex align-items-center text-muted px-2 py-0 rounded"
              style={{ backgroundColor: "#e9ecef", fontSize: "0.75rem" }}
            >
              <span className="badge bg-warning text-dark me-2" style={{fontSize: "0.65rem"}}>BETA</span>
              <span>v{version} &mdash; Actively evolving platform</span>
            </div>
          </div>

          {/* CENTER/RIGHT SECTION: Links */}
          <div className="d-flex align-items-center mt-2 mt-sm-0">
            <Link
              className="text-decoration-none text-secondary mx-2"
              style={{ fontSize: "0.85rem" }}
              to="https://pv-glarecheck.com/privacy-policy"
            >
              Privacy
            </Link>
            <span className="text-muted">|</span>
            <Link
              className="text-decoration-none text-secondary mx-2"
              style={{ fontSize: "0.85rem" }}
              to="https://pv-glarecheck.com/impressum"
            >
              Impressum
            </Link>
            <span className="text-muted">|</span>
            <Link
              className="text-decoration-none text-secondary mx-2"
              style={{ fontSize: "0.85rem" }}
              to="https://pv-glarecheck.com/contact"
            >
              Contact
            </Link>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Footer;